import React, { useState } from 'react'
import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  ListItemIcon,
  Grid,
  Dialog,
  DialogContent,
  IconButton,
  useMediaQuery,
  useTheme,
  Paper,
} from '@mui/material'
import FolderIcon from '@mui/icons-material/Folder'
import CloseIcon from '@mui/icons-material/Close'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import DocumentList from '../../Component/Document_Viewer/DocumentList'
import { IMAGE_BASE_PATH_DBRADC } from '../../Config/Config'
import AdmissionData from '../../Assets/JSON/Admission&Fee/Admission&Fee.json'

const AdmissionPage = () => {
  const [selectedItem, setSelectedItem] = useState(null)
  const [showDocumentList, setShowDocumentList] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const handleItemClick = (item) => {
    if (item.documents && item.documents.length > 0) {
      setSelectedItem(item)
      setShowDocumentList(true)
    } else {
      handleFileClick(item)
    }
  }

  const handleBackToList = () => {
    setShowDocumentList(false)
    setSelectedItem(null)
  }

  const handleFileClick = (file) => {
    if (!file.pathurl) {
      toast.error('There is no file')
      return
    }
    const isImage = ['.jpg', '.jpeg', '.png'].some((ext) =>
      file.pathurl.toLowerCase().endsWith(ext)
    )
    if (isImage) {
      setSelectedImage(IMAGE_BASE_PATH_DBRADC + file.pathurl)
    } else {
      navigate(`/Admission&Fee/${file.ID}/${file.filename}`, {
        state: { selectedDocData: file, fromList: '/Admission&Fee' },
      })
    }
  }

  return (
    <Box className="container py-5">
      <Typography variant="h5" sx={{ textAlign: 'center' }} mb={2}>
        Admission & Fee Structure
      </Typography>
      <Box width="30%" elevation={3} p={2}>
        {showDocumentList ? (
          <DocumentList
            data={selectedItem.documents}
            onBack={handleBackToList}
            onFileClick={handleFileClick}
          />
        ) : (
          <List>
            {AdmissionData[0].documents.map((item) => (
              <ListItemButton
                key={item.ID}
                onClick={() => handleItemClick(item)}
                selected={selectedItem?.ID === item.ID}
              >
                <ListItemIcon>
                  <FolderIcon />
                </ListItemIcon>
                <ListItemText
                  primary={item.filename}
                  secondary={item.description}
                  primaryTypographyProps={{ noWrap: true }}
                  secondaryTypographyProps={{ noWrap: true }}
                />
              </ListItemButton>
            ))}
          </List>
        )}
      </Box>
      <Dialog
        open={!!selectedImage}
        onClose={() => setSelectedImage(null)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            m: isMobile ? 1 : 4,
            width: '100%',
            maxWidth: '700px',
            borderRadius: 2,
          },
        }}
      >
        <IconButton
          onClick={() => setSelectedImage(null)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            zIndex: 1,
            backgroundColor: 'rgba(255,255,255,0.7)',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent
          sx={{
            p: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: isMobile ? '200px' : '400px',
            backgroundColor: '#f9f9f9',
          }}
        >
          <Box
            sx={{
              width: '100%',
              aspectRatio: '16/9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              background: '#eee',
            }}
          >
            <img
              src={selectedImage}
              alt="Preview"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                display: 'block',
                maxHeight: '80vh',
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  )
}

export default AdmissionPage
